// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  locatorsSearchEngineOptions: {
    key: 'AIzaSyDnICcEFA6yWhF7GZPtMLLRUvHeMcu4t5E',
    region: 'ca',
    bounds: {
      northeast: {
        lat: 45.7058381,
        lng: -73.47426
      },
      southwest: {
        lat: 45.410246,
        lng: -73.986345
      }
    }
  },
  arrondissements: [
    {name: 'Ahuntsic-Cartierville', code: 'AC',
    gname: 'Ahuntsic-Cartierville'},
    {name: 'Anjou', code: 'ANJ',
    gname: 'Anjou'},
    {name: 'Côte-des-Neiges–Notre-Dame-de-Grâce', code: 'CDNNDG',
    gname: 'Côte-Des-Neiges—Notre-Dame-De-Grâce'},
    {name: 'L\'Île-Bizard–Sainte-Geneviève', code: 'IBZSGV',
    gname: 'L\'Île-Bizard—Sainte-Geneviève'},
    {name: 'Lachine', code: 'LCH',
    gname: 'Lachine'},
    {name: 'LaSalle', code: 'LSL',
    gname: 'LaSalle'},
    {name: 'Le Plateau-Mont-Royal', code: 'PMR',
    gname: 'Le Plateau-Mont-Royal'},
    {name: 'Le Sud-Ouest', code: 'SO',
    gname: 'Le Sud-Ouest'},
    {name: 'Mercier–Hochelaga-Maisonneuve', code: 'MHM',
    gname: 'Mercier-Hochelaga-Maisonneuve'},
    {name: 'Montréal-Nord', code: 'MTN',
    gname: 'Montréal-Nord'},
    {name: 'Outremont', code: 'OUT',
    gname: 'Outremont'},
    {name: 'Pierrefonds-Roxboro', code: 'PFDROX',
    gname: 'Pierrefonds-Roxboro'},
    {name: 'Rivière-des-Prairies–Pointe-aux-Trembles', code: 'RDPPAT',
    gname: 'Riviere-des-Prairies—Pointe-aux-Trembles'},
    {name: 'Rosemont–La Petite-Patrie', code: 'RPP',
    gname: 'Rosemont—La Petite-Patrie'},
    {name: 'Saint-Laurent', code: 'SLR',
    gname: 'Saint-Laurent'},
    {name: 'Saint-Léonard', code: 'SLN',
    gname: 'Saint-Léonard'},
    {name: 'Verdun', code: 'VRD',
    gname: 'Verdun'},
    {name: 'Ville-Marie', code: 'VM',
    gname: 'Ville-Marie'},
    {name: 'Villeray–Saint-Michel–Parc-Extension', code: 'VSMPE',
    gname: 'Villeray—Saint-Michel—Parc-Extension'}
  ],
};



// WEBPACK FOOTER //
// C:/dev/Perso/urmeo/src/environments/environment.ts